import styled from "styled-components";

export const TextElement = styled.h1` 
    text-align: center;
`
export const TextHighlight = styled.span`
    color: deepskyblue;
    font-weight: bold;
`

export const ContentContainer = styled.div`
    display: flex;
    margin-top: 15px;
    gap: 20px;
    padding: 0 20px;

    @media (max-width: 1100px) {
        flex-direction: column;
        align-items: center;
    }
`

export const Input = styled.input`
    padding: 10px;
    font-size: 16px;
    border: 2px solid #ccc;
    border-radius: 5px;
    outline: none;
    transition: border-color 0.3s;
    width: 100%;
    max-width: 100px;
    &:focus {
        border-color: #007bff;
    }
    @media (max-width: 768px) {
        max-width: 100%;
        box-sizing: border-box;
    }
`;

export const Label = styled.label`
    text-align: right;
    font-weight: bold;
    padding-right: 15px;
    flex: 1;

    @media (max-width: 768px) {
        text-align: left;
        padding-right: 0;
    }
`

export const RowForm = styled.div`
    display: flex;
    padding-top: 10px;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
`

export const InputContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 400px;

    @media (max-width: 1100px) {
        max-width: 600px;
    }
`

export const ChartContainer = styled.div`
    width: 100%;
    margin: auto;
    position: relative;

    @media (max-width: 1100px) {
        margin-top: 30px;
    }
`